import {scrollToElement} from './scroll-to-element'

export function scrollTop(duration = 250) {
   scrollToElement({duration})
}
